module.exports = __webpack_public_path__ + "./fonts/d4eecd5ca1f9aaf0a4d8985099941c83.woff2";